<template>
  <div class="userConter" style="heigth:100%">
    <main>
      <template>
        <div class="userImg">
          <ul>
            <li v-if="!$privatization" style="margin-right:40px;">
              <img :src="formLabelAlign.avatar" alt />
            </li>
            <li v-if="$privatization" style="margin-right:40px;">
              <img src="../assets/imgs/home/moren_tx.png" alt="用户头像" />
            </li>
            <!-- <li>
              <p @click="messageIf('head_portrait')">点击修改头像</p>
              <span>*支持jpeg、jpg、png类型文件,大小不超过2M</span>
            </li> -->
          </ul>
        </div>
        <div class="form-item-info">
          <el-form :label-position="labelPosition" label-width="140px" :model="formLabelAlign">
            <el-form-item v-if="formLabelAlign.name">
              <div class="label-box" slot="label">
                <img class="scoped-icon" src="@/assets/imgs/memory/userCenter/edit_user.png"
                  alt />姓&nbsp;&nbsp;&nbsp;&nbsp;名：
              </div>
              <p>
                <span class="item-left">{{formLabelAlign.name}}</span>
                <!-- <span class="item-right" @click="messageIf('name')">修改</span> -->
              </p>
            </el-form-item>
            <el-form-item v-if="!$privatization">
              <div class="label-box" slot="label">
                <img class="scoped-icon" src="@/assets/imgs/memory/userCenter/wechat.png" alt />微信名：
              </div>
              <p>
                <span class="item-left">{{wxName}}</span>
                <span v-if="!formLabelAlign.openid" class="item-right" @click="messageIf('30')">绑定</span>
              </p>
            </el-form-item>
            <el-form-item v-if="formLabelAlign.phone">
              <!-- edit_email -->
              <div class="label-box" slot="label"><img class="scoped-icon"
                  src="@/assets/imgs/memory/userCenter/edit_phone.png" alt="">{{account}}</div>
              <p><span class="item-left">{{formLabelAlign.phone}}</span><span class="item-right" v-if="!$privatization"
                  @click="messageIf('phone')">修改</span></p>
              <!-- <p v-if="!myPhone"><span class="item-left">{{formLabelAlign.phone}}</span><span class="item-right"
                  @click="messageIf('29')">绑定</span></p> -->
            </el-form-item>
            <el-form-item v-if="formLabelAlign.email">
              <!-- edit_email -->
              <div class="label-box" slot="label"><img class="scoped-icon"
                  src="@/assets/imgs/memory/userCenter/edit_email.png" alt="">{{accountEmail}}</div>
              <p><span class="item-left">{{formLabelAlign.email}}</span><span class="item-right" v-if="!$privatization"
                  @click="messageIf('email')">修改</span></p>
              <!-- <p v-if="!myPhone"><span class="item-left">{{formLabelAlign.phone}}</span><span class="item-right"
                  @click="messageIf('29')">绑定</span></p> -->
            </el-form-item>
            <el-form-item>
              <div class="label-box" slot="label"><img class="scoped-icon"
                  src="@/assets/imgs/memory/userCenter/password.png" alt="">密码：</div>
              <p><span class="item-left">******</span><span class="item-right" @click="messageIf('pwd')">重置</span></p>
              <!-- <p v-if="!myPhone"><span class="item-left">{{formLabelAlign.phone}}</span><span class="item-right"
                  @click="messageIf('29')">绑定</span></p> -->
            </el-form-item>
            <!-- <el-form-item>
            <div class="label-box" slot="label"><img class="scoped-icon" src="@/assets/imgs/memory/userCenter/edit_email.png" alt="">邮&nbsp;&nbsp;&nbsp;&nbsp;箱：</div>
            <p><span class="item-left">{{formLabelAlign.email || "暂无"}}</span><span class="item-right" @click="messageIf('email')">修改</span></p>
            </el-form-item> -->
            <el-form-item>
              <div class="label-box" slot="label">
                <img class="scoped-icon" src="@/assets/imgs/memory/userCenter/edit_lang.png" alt />擅长语言：
              </div>
              <div class="item-list">
                <span class="cur item-block" @click="messageIf('language')">选择语言</span>
                <template v-for="(item, index) in formLabelAlign.goodAtLanguage">
                  <span class="item-block item-block-list" :key="index">
                    {{item.langName}}
                    <i class="scoped-close el-icon-close"
                      @click="removeItem(formLabelAlign.goodAtLanguage, index,'goodAtLanguage')"></i>
                  </span>
                </template>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="label-box" slot="label">
                <img class="scoped-icon" src="@/assets/imgs/memory/userCenter/edit_field.png" alt />擅长领域：
              </div>
              <div class="item-list">
                <span class="cur item-block" @click="messageIf('field')">选择领域</span>
                <template v-for="(item, index) in formLabelAlign.goodAtField">
                  <span class="item-block item-block-list" :key="index">
                    {{item.domainName}}
                    <i class="scoped-close el-icon-close"
                      @click="removeItem(formLabelAlign.goodAtField, index,'goodAtField')"></i>
                  </span>
                </template>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </main>
    <messageBox v-if="mesBox" :isShow="mesBox" :tit="title" txt :mesShow="mesShow" :params="params" :imgSrc="imgSrc1"
      ifForm="1" @message="showMesBox" @messageIf="messageIf"></messageBox>

  </div>
</template>

<script>
import myTitle from "@/common/title.vue";
import messageBox from "@/common/messageBox.vue";

import langC from "@/common/edit/lang";
import fieidC from "@/common/edit/fieid";

export default {
  name: "userConter",
  inject: ['reload'],
  data () {
    return {
      labelPosition: "left",
      formLabelAlign: {
        name: "",
        pwd: "",
        phone: "",
        email: "",
        nickName: "",
        goodAtLanguage: [],
        goodAtField: [],
        openid: ""
      },
      mesShow: "22",
      title: "",
      mesBox: false,
      imgSrc1: require("../assets/imgs/memory/popup_background.png"), // 弹窗title背景图
      goodAtLanguage: [],
      goodAtField: [],
      params: {},
      myPhone: true,
      hospitalFlag: true,//显示领域
      account: "手机号：",//账号
      accountEmail: "邮箱：",
      userId: "",
    };
  },
  computed: {
    wxName () {
      return this.formLabelAlign.openid ? this.formLabelAlign.nickName : "未绑定"
    },
  },
  created () {
    this.infoInit();
    // 判断用户是否关联手机号
    let myPhone = this.formLabelAlign.phone
    //account
    console.log(this.$privatization)
    this.$privatization ? this.account = '用户名' : this.account = "手机号："
    if (myPhone !== '') {
      this.myPhone = true
    } else {
      this.myPhone = false
    }

  },
  updated () {
    let myPhone = this.formLabelAlign.phone

    if (myPhone !== '') {
      this.myPhone = true
    } else {
      this.myPhone = false
    }
  },
  methods: {
    removeItem (data, index, type) {
      var that = this;
      // 调用删除/编辑事件
      var ary = [];
      data.forEach(item => {
        delete item.userId;
        delete item.id;
        ary.push(item)
      });
      ary.splice(index, 1);
      if (type == "goodAtLanguage") {
        var params = {
          deleteLangList: data,
          addLangList: ary
        }
      } else if (type == "goodAtField") {
        var params = {
          deleteDomainList: data,
          addDomainList: ary
        }
      }
      this.catReq1Service("/api/v1/user/update", params)
        .then(function (response) {
          if (!response.success) {
            return
          }
          that.$delete(data, index)
          that.$message({
            message: "删除成功!",
            type: "success"
          });
        })
    },

    async infoInit () {
      let that = this;
      const response = await this.catReq1Service("/api/v1/user/getOldUserInfo");
          if (response && response.resultCode === "1") {
            if (response.result) {
              that.formLabelAlign.avatar = response.result.avatar;
              localStorage.setItem("myUserImg", response.result.avatar); // 头像
              localStorage.setItem("myUserName", response.result.nickName); // 昵称
              that.formLabelAlign.name = response.result.aliasName;
              that.formLabelAlign.nickName = response.result.nickName;
              that.formLabelAlign.phone = response.result.loginPhone;
              that.formLabelAlign.email = response.result.email;
              that.formLabelAlign.openid = response.result.openid;
              that.formLabelAlign.goodAtLanguage = response.result.userLangList;
              that.formLabelAlign.goodAtField = response.result.userDomainList;
              that.userId = response.result.id;

            }
          }
    },

    // 新建库弹窗 --确定键事件
    async showMesBox (data) {
      // , mesShow
      console.log(data)
      let that = this;
      var mesShow = this.mesShow;
      console.log(that.formLabelAlign.goodAtLanguage, "that.formLabelAlign.goodAtLanguage")
      this.$message.closeAll();
      let arr = that.formLabelAlign.goodAtLanguage || [];
      let ary = that.formLabelAlign.goodAtField || [];
      if (arr.length < 1 && mesShow == "27") {
        this.$message({
          message: "添加成功",
          type: "success"
        });
      } else if (ary.length < 1 && mesShow == "28") {
        this.$message({
          message: "添加成功",
          type: "success"
        });

      } else {
        this.$message({
          message: "修改成功",
          type: "success"
        });
      }

      if (mesShow == "22") {
        // 修改头像
        // console.log(data, "line 100");
      } else if (mesShow == "23") {
        // 修改姓名
        this.formLabelAlign.name = data;
      } else if (mesShow == "24") {
        // 修改密码
        // this.formLabelAlign.email = data;
        //  this.formLabelAlign.password = data;
      } else if (mesShow == "25") {
        // 修改手机号
        this.formLabelAlign.phone = data;
      } else if (mesShow == "26") {
        // 修改邮箱
        this.formLabelAlign.email = data;
      } else if (mesShow == "27") {
        // 修改语言
        this.formLabelAlign.goodAtLanguage = data.list;
      } else if (mesShow == "28") {
        // 修改领域
        this.formLabelAlign.goodAtField = data.list;
      } else if (mesShow == "29") {
        // 绑定手机号
        // this.formLabelAlign.goodAtField = data.list;
        this.formLabelAlign.phone = data;
      } else if (mesShow == "30") {
        // this.reload()
        await this.infoInit()
        this.$router.go(0)
      }
      this.mesBox = false;
    },
    // 新建库弹窗
    messageIf (type) {
      var ary = [];
      if (type == "head_portrait") {
        ary = ["22", "修改头像", {}];
      } else if (type == "name") {
        ary = [
          "23",
          "修改姓名",
          {
            name: this.formLabelAlign.name
          }
        ];
      } else if (type == "pwd") {
        ary = ["24", "重置密码", { phone: this.formLabelAlign.phone, email: this.formLabelAlign.email }];
      } else if (type == "phone") {
        ary = [
          "25",
          "修改手机号",
          {
            phone: this.formLabelAlign.phone
          }
        ];
      } else if (type == "email") {
        ary = [
          "26",
          "修改邮箱",
          {
            email: this.formLabelAlign.email
          }
        ];
      } else if (type == "language") {
        ary = [
          "27",
          "选择语言",
          {
            list: langC.toDataAry_un(this.formLabelAlign.goodAtLanguage),
            name: this.formLabelAlign.name
          }
        ];
      } else if (type == "field") {
        ary = [
          "28",
          "选择领域",
          {
            list: fieidC.toDataAry_ly(this.formLabelAlign.goodAtField),
            name: this.formLabelAlign.name
          }
        ];
      } else if (type == "29") {
        ary = [
          "29",
          "绑定手机号",
          {
            phone: this.formLabelAlign.phone
          }
        ];
      } else if (type == "30") {
        ary = [
          "30",
          "扫码绑定微信",
          {
            id: this.userId
          }
        ];
      }
      this.mesShow = ary[0];
      this.title = ary[1];
      this.params = ary[2];
      this.mesBox = !this.mesBox;
    }
  },
  components: {
    myTitle,
    messageBox
  }
};
</script>
<style lang="less" scoped>
// .userConter {
//   height: 100%;
// }
main {
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
  // border-radius: 6px;
  // margin-top: 20px;
  padding: 20px;
  position: relative;
  // min-height: 723px;
  // height: calc(100% - 84px);
}
.userImg {
  width: 450px;
  margin: 50px auto 80px;
  margin-bottom: 40px;
  ul {
    height: 130px;
    li {
      display: inline-block;
      text-align: left;
      p {
        font-size: 18px;
        color: #2579cf;
        margin: 40px 0 15px 0px;
        cursor: pointer;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
      span {
        font-size: 14px;
        color: #999999;
      }
    }
  }
  img {
    width: 130px;
    height: 130px;
    border-radius: 75px;
    // border: 1px solid #ccc;
  }
}
.el-input.is-disabled .el-input__inner {
  background-color: #fff !important;
  border-color: #e4e7ed;
  color: #c0c4cc;
}
.el-input {
  width: 90% !important;
}
.el-input__inner {
  width: 90% !important;
}
.form-item-info {
  width: 610px;
  margin: 0 auto;
  text-align: left;
  font-size: 14px;
}
.item-left {
  display: inline-block;
  vertical-align: middle;
  width: 320px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(69, 69, 69, 1);
}
.item-right {
  color: rgba(34, 34, 34, 1);
  cursor: pointer;
}
.item-list {
  overflow: hidden;
  line-height: 32px;
}
.item-block {
  // padding:10px;
  // height: 145px;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 17px;
  background: #0C77DA;
  color: #ffffff;
  font-size: 14px;
  border-radius: 6px;
  float: left;
}
.item-block-list {
  padding: 0 11px;
  background: #11A4FF;
}
.item-block:hover {
}
.cur {
  cursor: pointer;
}
.scoped-icon {
  padding-right: 18px;
  vertical-align: middle;
  width: 27px;
}
.scoped-close {
  cursor: pointer;
  padding-left: 5px;
}
.label-box {
  font-size: 16px;
}
</style>